<template src="./Edit.html"></template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store.dispatch("users/getFeatures");
        this.$store.dispatch("lookups/getLookups");

        this.$store
            .dispatch("users/getForEdit", this.itemId)
            .then((res) => {
                this.user = res;
            })
            .catch(() => { });
    },
    computed: {
        systemTypes(){
          return [
            {value:true,label:"واجهة الادارة"},
            {value:false,label:"واجهة الموظف"},
          ]

        },
        features() {
            return this.$store.state.users.features;
        },
        userTypes() {
            return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.UserTypes)
        }
    },
    data() {
        return {
            user: {
                isMainSystem: false,
                userTypeId: null,
                permissions: [],
            },
        };
    },
    methods: {
        changeCheckbox() {
            this.user.permissions = [];
            this.user.userTypeId = null;
            this.HandleChange();
        },
        confirm() {

            this.$store
                .dispatch("users/edit", { id: this.itemId, payload: this.user })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        CheckAll(feature) {
            feature.permissions.forEach((permission) => {
                if (feature.checkAll) {
                    if (!this.user.permissions.includes(permission.permissionId)) {
                        this.user.permissions.unshift(permission.permissionId);
                    }
                } else {
                    if (this.user.permissions.includes(permission.permissionId)) {
                        let index = this.user.permissions.indexOf(permission.permissionId);
                        this.user.permissions.splice(index, 1);
                    }
                }
            });
        },

        HandleChange(feature) {
            feature.checkAll = true;
            feature.permissions.forEach((permission) => {
                if (!this.user.permissions.includes(permission.permissionId)) {
                    feature.checkAll = false;
                }
            });
        },
        allowedDates(val) {
            const today = new Date();
            const date = new Date(val);
            return date < today;
        },
        back() {
            this.$emit("back");
        },
    },
};
</script>
